import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import useRolePermissions from 'hooks/useRolePermissions'
import React, { useMemo } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { scrollBar } from 'styles/theme'
import NotificationsGroup from './NotificationsGroup'
import useNotificationsList from './useNotificationsFeed'

const useStyles = makeStyles(theme => ({
  notificationsFeedRoot: {
    height: '100%',
    overflowY: 'scroll',
    ...scrollBar
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20
  }
}))

const NotificationsFeed = () => {
  const classes = useStyles()
  const { notificationGroups, totalNotifications, fetchNextPage, hasMorePages } = useNotificationsList()
  const { permissions, isDsoUser, isHiUser } = useRolePermissions()

  const showPracticeNames = useMemo(
    () => permissions.searchByDoctor || isDsoUser || isHiUser,
    [permissions.searchByDoctor, isDsoUser, isHiUser]
  )

  return (
    <div id="notifications-feed" className={classes.notificationsFeedRoot}>
      <InfiniteScroll
        dataLength={totalNotifications}
        scrollableTarget="notifications-feed"
        next={fetchNextPage}
        hasMore={hasMorePages}
        loader={
          <div className={classes.loaderContainer}>
            <CircularProgress size={12} style={{ color: 'var(--text-color-25)' }} />
          </div>
        }
      >
        {notificationGroups.map(group => (
          <NotificationsGroup
            key={`notifications-group-${group.key}`}
            notificationGroup={group}
            showPracticeNames={showPracticeNames}
          />
        ))}
      </InfiniteScroll>
    </div>
  )
}

export default NotificationsFeed
